import { render, staticRenderFns } from "./SafeFooter.vue?vue&type=template&id=78642e89&scoped=true&"
import script from "./SafeFooter.vue?vue&type=script&lang=js&"
export * from "./SafeFooter.vue?vue&type=script&lang=js&"
import style0 from "./SafeFooter.vue?vue&type=style&index=0&id=78642e89&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78642e89",
  null
  
)

export default component.exports